import React, { useState, useEffect, useRef } from "react";

const playWhenAllowed = (mediaElement) => {
  const playPromise = mediaElement?.play();
  if (playPromise?.catch) {
    playPromise.catch(() => {});
  }
};

export default function PlayAudio() {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
        // Show loading animation.
     playWhenAllowed(audio);
    }
  }, []);

  return (
    <>
      
      <audio ref={audioRef} loop>
        <source src="/audio.mp3" type="audio/mpeg" />
      </audio>
     
    </>
  );
}
